// SWAHILI WORDS
const swahili = [
   
]

export default swahili